import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiArrowRight, FiCheck, FiUser, FiPhone, FiBriefcase, FiMail, FiMapPin, FiMessageSquare } from 'react-icons/fi';
import { API_BASE_URL } from '../services/api';

const initialFormData = {
  company_name: '',
  contact_person: '',
  phone: '+998 ',
  email: '',
  city: 'Toshkent',
  projects_count: '',
  message: '',
};

const AdBanner = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [showForm, setShowForm] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState(initialFormData);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      const response = await fetch(`${API_BASE_URL}/partnership/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setIsSubmitted(true);
      } else {
        const data = await response.json().catch(() => ({}));
        setError(data.detail || "Ma'lumotlarni tekshiring va qayta urining.");
      }
    } catch (err) {
      setError("Tarmoq xatosi. Internetni tekshirib, qayta urining.");
    }

    setIsSubmitting(false);
  };

  return (
    <section className="ad-banner" ref={ref} id="partnership">
      <div className="ad-banner-inner">
        <motion.div
          className="ad-banner-card"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <div className="ad-banner-glow" />

          <AnimatePresence mode="wait">
            {isSubmitted ? (
              /* ===== SUCCESS ===== */
              <motion.div
                key="success"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0 }}
                style={{ textAlign: 'center', padding: '40px 0' }}
              >
                <div style={{
                  width: 80, height: 80, borderRadius: '50%', margin: '0 auto 24px',
                  background: 'linear-gradient(135deg, #22C55E, #16A34A)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  boxShadow: '0 12px 40px rgba(34, 197, 94, 0.3)',
                }}>
                  <FiCheck size={40} color="#fff" />
                </div>
                <h2 style={{ color: 'var(--gold)', marginBottom: 12 }}>Ariza qabul qilindi!</h2>
                <p style={{ color: 'var(--text-secondary)', maxWidth: 400, margin: '0 auto', lineHeight: 1.7 }}>
                  Rahmat, <strong style={{ color: 'var(--gold)' }}>{formData.company_name}</strong>!
                  Mutaxassisimiz 24 soat ichida <strong style={{ color: 'var(--gold)' }}>{formData.phone}</strong> raqamiga qo'ng'iroq qiladi.
                </p>
                <p style={{ color: 'var(--text-hint)', fontSize: 13, marginTop: 16 }}>
                  Ariza raqami: HMK-{Date.now().toString().slice(-6)}
                </p>
              </motion.div>
            ) : !showForm ? (
              /* ===== BANNER ===== */
              <motion.div
                key="banner"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                style={{ textAlign: 'center' }}
              >
                <h2>
                  Qurilish kompaniyasimisiz? <span className="gold-text">Biz bilan ishlang!</span>
                </h2>
                <p>
                  OSTONA platformasida o'z loyihalaringizni joylashtiring va minglab potensial
                  xaridorlarga yeting. Keng auditoriya, shaffof hamkorlik va professional xizmat.
                </p>
                <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap', marginTop: 8 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-secondary)', fontSize: 14 }}>
                    <FiCheck color="var(--gold)" /> Bepul joylashtirish
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-secondary)', fontSize: 14 }}>
                    <FiCheck color="var(--gold)" /> 1000+ foydalanuvchi
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-secondary)', fontSize: 14 }}>
                    <FiCheck color="var(--gold)" /> Professional qo'llab-quvvatlash
                  </div>
                </div>
                <button className="btn-gold" onClick={() => setShowForm(true)} style={{ marginTop: 24 }}>
                  Hamkorlik uchun ariza qoldirish <FiArrowRight />
                </button>
              </motion.div>
            ) : (
              /* ===== FORM ===== */
              <motion.div
                key="form"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
              >
                <h2 style={{ textAlign: 'center', marginBottom: 8 }}>
                  <span className="gold-text">Hamkorlik arizasi</span>
                </h2>
                <p style={{ textAlign: 'center', color: 'var(--text-secondary)', marginBottom: 28, fontSize: 14 }}>
                  Ma'lumotlaringizni qoldiring, biz siz bilan bog'lanamiz
                </p>

                <form onSubmit={handleSubmit} style={{ maxWidth: 560, margin: '0 auto' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                    {/* Kompaniya nomi */}
                    <div style={{ gridColumn: 'span 2' }}>
                      <div className="form-field">
                        <FiBriefcase className="form-icon" />
                        <input
                          type="text" name="company_name" placeholder="Kompaniya nomi *"
                          value={formData.company_name} onChange={handleChange} required
                        />
                      </div>
                    </div>

                    {/* Ism */}
                    <div className="form-field">
                      <FiUser className="form-icon" />
                      <input
                        type="text" name="contact_person" placeholder="Aloqa shaxsi *"
                        value={formData.contact_person} onChange={handleChange} required
                      />
                    </div>

                    {/* Telefon */}
                    <div className="form-field">
                      <FiPhone className="form-icon" />
                      <input
                        type="tel" name="phone" placeholder="+998 90 123 45 67 *"
                        value={formData.phone} onChange={handleChange} required
                      />
                    </div>

                    {/* Email */}
                    <div className="form-field">
                      <FiMail className="form-icon" />
                      <input
                        type="email" name="email" placeholder="Email"
                        value={formData.email} onChange={handleChange}
                      />
                    </div>

                    {/* Shahar */}
                    <div className="form-field">
                      <FiMapPin className="form-icon" />
                      <select name="city" value={formData.city} onChange={handleChange}>
                        <option value="Toshkent">Toshkent</option>
                        <option value="Samarqand">Samarqand</option>
                        <option value="Buxoro">Buxoro</option>
                        <option value="Namangan">Namangan</option>
                        <option value="Andijon">Andijon</option>
                        <option value="Farg'ona">Farg'ona</option>
                        <option value="Boshqa">Boshqa</option>
                      </select>
                    </div>

                    {/* Loyihalar soni */}
                    <div style={{ gridColumn: 'span 2' }}>
                      <div className="form-field">
                        <FiBriefcase className="form-icon" />
                        <select name="projects_count" value={formData.projects_count} onChange={handleChange}>
                          <option value="">Loyihalar soni</option>
                          <option value="1">1 ta loyiha</option>
                          <option value="2-5">2-5 ta loyiha</option>
                          <option value="5-10">5-10 ta loyiha</option>
                          <option value="10+">10+ loyiha</option>
                        </select>
                      </div>
                    </div>

                    {/* Xabar */}
                    <div style={{ gridColumn: 'span 2' }}>
                      <div className="form-field" style={{ alignItems: 'flex-start' }}>
                        <FiMessageSquare className="form-icon" style={{ marginTop: 12 }} />
                        <textarea
                          name="message" placeholder="Qo'shimcha xabar (ixtiyoriy)"
                          value={formData.message} onChange={handleChange}
                          rows={3} style={{ resize: 'vertical' }}
                        />
                      </div>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: 12, marginTop: 20, justifyContent: 'center' }}>
                    <button
                      type="button"
                      onClick={() => {
                        setShowForm(false);
                        setIsSubmitted(false);
                        setFormData(initialFormData);
                        setError('');
                      }}
                      style={{
                        background: 'transparent', border: '1px solid var(--border)',
                        color: 'var(--text-secondary)', padding: '14px 28px', borderRadius: 12,
                        fontSize: 14, cursor: 'pointer', fontFamily: 'inherit', fontWeight: 600,
                      }}
                    >
                      Bekor qilish
                    </button>
                    <button
                      type="submit"
                      className="btn-gold"
                      disabled={isSubmitting}
                      style={{ opacity: isSubmitting ? 0.7 : 1 }}
                    >
                      {isSubmitting ? 'Yuborilmoqda...' : 'Arizani yuborish'} <FiArrowRight />
                    </button>
                  </div>
                  {error && (
                    <div style={{ marginTop: 12, color: '#ff6b6b', fontSize: 13, textAlign: 'center' }}>
                      {error}
                    </div>
                  )}
                </form>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
};

export default AdBanner;
